export default "__VITE_ASSET__RDJndvHo__"